/* eslint-disable */
import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/views/Home.vue';
import Main from '@/Main.vue';
Vue.use(VueRouter);
const routes = [
    {
        path: '/',
        redirect: '/home',
        component: Main,
        children: [
            {
                path: '/home',
                title: '工作台',
                name: 'home',
                component: Home
            },
            {
                path: '/aboutUs',
                title: '关于我们',
                name: 'abouUs',
                component: () => import('@/views/aboutUs.vue')
            },
            {
                path:'/contact_us',
                title:'联系我们',
                name: 'news',
                meta:{
                    title:"联系我们",
                    keepAlive:true
                },
                component: () => import('@/views/contact_us.vue')
            },
            {
                path:'/download',
                title:'资料下载',
                name: 'news',
                meta:{
                    title:"资料下载",
                    keepAlive:true
                },
                component: () => import('@/views/download.vue')                
            }

        ]
    }
];

const router = new VueRouter({
    routes
});
router.beforeEach(async (to, from, next) => {
    next()
});
export default router
